import OptionConst from "@/const/Option";
import { ShinseiInfo } from "@/types/Dakoku";

export class ConvertUtil {

  /**
   *
   * @param str 変換したい数値文字列
   * @param nanToNull NaNをnullに変換するか（初期値true）
   * @returns 変換後の文字列 | null
   */
  public static stringToInt(str: string){
    let parsed: number | null = parseInt(str, 10)
    return isNaN(parsed) ? null : parsed
  }

  public static removeNonNumeric = (val: string | null, allowHyphen: boolean = false) => {
    if(!val){
      return null
    }

    if(allowHyphen){
      return val.replace(/[^0-9\-]/g,'')
    }else{
      return val.replace(/[^0-9]/g,'')
    }
  }

  public static getShinseiLabel = (shinseis: ShinseiInfo[]) => {
    let shinsei = ''
    shinsei += shinseis.map(ele => {
      let str = OptionConst.SHINSEI_OPTION.find(opt => {
        return opt.val == ele.shinsei_type
      })?.label
      return str ? str + '申請' : ''
    });
    return shinsei
  }
}
